import { useEffect, useState } from "react";
import { compose } from "redux";

import JSONTree from "react-json-tree";

import TextField from "@material-ui/core/TextField";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";

import ApiButton from "../../../../shared/ui/Api.Button";

import { userDepotConnector } from "../../../../services/users/depot/connector";
import { allClaimsOtherThanAml } from "../../../../shared/ClaimLists/Claim.Aml.All.List";
import PropTypes from "prop-types";
import { supportedCurrencies } from "../../../../services/users/organisations/helper";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";

const LenderDepotComponentInternal = (props) => {
  useEffect(() => {
    if (!props.depot.data[props.accountId]) props.getDepot(props.accountId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const data = props.depot.data[props.accountId] ?? {};

  var [newDepotName, setNewDepotName] = useState("");
  var [newDepotCurrency, setNewDepotCurrency] = useState(
    supportedCurrencies[0].value,
  );

  function addNewDepot() {
    props.addDepot(props.accountId, newDepotName, newDepotCurrency);
  }

  return (
    <div>
      <h4>Depot Summary</h4>
      <div>
        <JSONTree hideRoot={true} data={data} />
      </div>
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Add new depot</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <TextField
              size="small"
              variant="outlined"
              label="Depot Name"
              style={{ flexBasis: "33%" }}
              value={newDepotName}
              onChange={(e) => setNewDepotName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <TextField
              label="Currency"
              size="small"
              variant="outlined"
              select
              id="CurrencyForOriginator"
              value={newDepotCurrency}
              onChange={(e) => setNewDepotCurrency(e.target.value)}
            >
              {supportedCurrencies.map((currency) => {
                return (
                  <MenuItem key={currency.value} value={currency.value}>
                    {" "}
                    {currency.label}{" "}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <Button variant="contained" color="primary" onClick={addNewDepot}>
                Add depot
              </Button>
            </ClaimsWrapper>
          </div>
        </div>
        <div className="row"></div>
      </div>
    </div>
  );
};

LenderDepotComponentInternal.propTypes = {
  depot: PropTypes.object,
  accountId: PropTypes.string,
  getDepot: PropTypes.func,
  addDepot: PropTypes.func,
};

const BorrowerDepotComponentInternal = (props) => {
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (!props.depot.data[props.accountId])
      props.getBorrowerDepot(props.accountId, props.depotId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transferToSavelend = () => {
    props.transferMoneyToSavelendAccount(props.identity, amount);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const data = props.depot.data[props.accountId] ?? {};

  return (
    <div>
      <h4>Transfer To Savelend Account</h4>
      <div>
        <JSONTree hideRoot={true} data={data} />
        <TextField
          size="small"
          variant="outlined"
          value={amount}
          onChange={handleAmountChange}
          fullWidth={true}
          label="Amount"
        />
        <br />
        <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
          <ApiButton
            buttonLabel={"Transfer"}
            onButtonClick={transferToSavelend}
            sending={props.depot.transfer.sending}
            sent={props.depot.transfer.sent}
            error={props.depot.transfer.error}
          />
        </ClaimsWrapper>
      </div>
    </div>
  );
};

BorrowerDepotComponentInternal.propTypes = {
  depot: PropTypes.object,
  currentUser: PropTypes.object,
  accountId: PropTypes.string,
  depotId: PropTypes.string,
  identity: PropTypes.string,
  getBorrowerDepot: PropTypes.func,
  transferMoneyToSavelendAccount: PropTypes.func,
};

export const BorrowerDepotComponent = compose(userDepotConnector)(
  BorrowerDepotComponentInternal,
);
export const LenderDepotComponent = compose(userDepotConnector)(
  LenderDepotComponentInternal,
);

export default LenderDepotComponent;
